import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Contribution() {
  const menu = [
    {
      name: "Overview",
      id: "Contribution-0",
    },
    {
      name: "1. Database & Software tool (For scientific research)",
      id: "Contribution-1",
    },
    {
      name: "2. For AI in synthetic biology",
      id: "Contribution-2",
    },
    {
      name: "3. For popularization of science",
      id: "Contribution-3",
    },
    {
      name: "4. Entrepreneurship (For transformation of scientific research achievements)",
      id: "Contribution-4",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Contribution:</p>
        <p className="subtitle" key={"Contribution-0"} id="Contribution-0">
          • Overview:
        </p>
        <ContentCard
          content={` 
            <p>
            Protein delivery is crucial in modern medicine, enabling targeted treatment for various diseases. The extracellular contractile injection systems (eCISs) have emerged as a precise and efficient delivery system compared to traditional methods. However, the current screening and identification of eCISs still demand substantial time and effort, lacking a rapid and efficient high-throughput screening approach.
            </p>
            <br/>
            <p>
            Therefore, we launched BioRocket, hoping to utilize machine learning algorithms to develop a more accurate and efficient gene discovery method. Moreover, we strive to make our impact on multiple fronts, from mono-disciplinary to cross-disciplinary, from professional scientific communication to popularization of science, from research results to social applications.
            </p>
              `}
        />
        <p className="subtitle" key={"Contribution-1"} id="Contribution-1">
          1. Database & Software tool (For scientific research)
        </p>
        <ContentCard
          content={` 
            <p>
            By BioRocket eCIS mining algorithm and wet lab validation, we identified 5,524 novel eCISs, enriching the existing eCIS database. In addition, by sequence alignment of the afp13 homologous proteins (tail fibre protein) we have identified, we found the variable regions (potential binding domain) for editing and annotated.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure1.png'
            alt='Figure 1. The 5,524 novel eCISs that we identified'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 1. The 5,524 novel eCISs that we identified
            </p>
            <br/>
            <p>
            It is also worth noting that not only did we share the database, we also organized the data analysis process into a workflow, future iGEMers can easily process their own data using BioRocket tools on GitLab.
            </p>
            <br/>
            <p>
            Besides, we launched BioRocket online platform with 2 main functions: Online Prediction for individual synthetic biologists to realize real-time prediction that the sequence uploaded by users is an eCIS or not. Online Inquiry for doctors and pharmaceutical companies to query the programmable regions of different eCISs.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure2.png'
            alt='Figure 2. Users can submit their own genomic data for real-time eCIS mining via the BioRocket cloud server'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 2. Users can submit their own genomic data for real-time eCIS mining via the BioRocket cloud server
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure3.jpeg'
            alt='Figure 3. Users can access data from the BioRocket database online. For the afp13 homologous protein, it is also possible to view its programmable region'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 3. Users can access data from the BioRocket database online. For the afp13 homologous protein, it is also possible to view its programmable region
            </p>
            <br/>
            <p>
            BioRocket now provides a holistic understanding of eCISs across diverse organisms, opening the door to groundbreaking discoveries. This is an improvement on the current lack of eCIS data, especially the programmability data, and provides information for future iGEMers interested in the study of the eCISs and microbiome.
            </p>
            <br/>
            <p>
            For details, see <a href="https://2023.igem.wiki/sysu-software/model">Model</a> and <a href="https://2023.igem.wiki/sysu-software/software">Software</a>.
            </p>
              `}
        />
        <p className="subtitle" key={"Contribution-2"} id="Contribution-2">
          2. For AI in synthetic biology
        </p>
        <ContentCard
          content={` 
            <p>
            Looking back in history, the emergence of new technologies has always had impacts on society that were challenging to estimate during their respective eras. These impacts could be both positive and negative. Artificial Intelligence and synthetic biology are both new technologies, and when AI is used in synthetic biology, it’s no doubt to fundamentally transform society. So, we made extensive discussions and exchanges, making some output.
            </p>
            <br/>
            <p>
            We first organized an AI for Syn-Bio webinar, primarily focusing on <b>whether artificial intelligence algorithms and data should be open-source</b> and the potential <b>challenges AI applied to synthetic biology</b> might encounter. Several teams participated in the online discussion and some valuable insights were generated.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure4.png'
            alt='Figure 4. Poster of the AI for Syn-Bio webinar organized by our team'
            class='content-figure'
            style='width:40%'
            />
            </div>
            <p class='content-legend'>
            Figure 4. Poster of the AI for Syn-Bio webinar organized by our team
            </p>
            <br/>
            <p>
            Furthermore, we were fortunate to collaborate with the team from the University of Oxford to conduct a series of discussions focused on the application and regulation of AI in synthetic biology. As a result of our collaboration, a written output - <i><b>Investigation and Reflections on Policies for Artificial Intelligence Uses in Synthetic Biology</b></i> was generated. This collaboration allowed us to delve into this specific area in depth and explore the complexities surrounding it.
            </p>
            <br/>
            <p>
            For details, see <a href="https://2023.igem.wiki/sysu-software/human-practices">Integrated HP</a>.
            </p>
              `}
        />
        <p className="subtitle" key={"Contribution-3"} id="Contribution-3">
          3. For popularization of science
        </p>
        <ContentCard
          content={` 
            <p>
            We actively engaged in events such as the iGEM conference in South China and CCiC, where we shared our solutions with researchers from various fields (for more details, see the Human Practices section). It's gratifying to incorporate new perspectives into our project and drive its improvement. Through these interactions, we have noticed a growing interest in synthetic biology, iGEM, and our project, BioRocket. This increasing awareness is both significant and motivating, inspiring us to continually improve BioRocket.
            </p>
            <br/>
            <p>
            Additionally, we created an informative poster to explain Feng Zhang's team's work in eCIS analysis, aimed at improving public understanding of synthetic biology. Through this visually engaging medium, the general public gains insight into the fundamental structure of eCISs and the strategies employed by researchers to modify it. They can also grasp its potential applications in drug delivery, thereby fostering a deeper appreciation for synthetic biology. It is worth noting that our poster garnered the second prize in the college's literature reading competition, underscoring the impact of our efforts in expanding the social awareness and influence of synthetic biology.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure5.png'
            alt='Figure 5. Poster showcasing the latest advances in eCIS research'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 5. Poster showcasing the latest advances in eCIS research
            </p>
            <br/>
            <p>
            For details, see <a href="https://2023.igem.wiki/sysu-software/human-practices">Integrated HP</a>.
            </p>
              `}
        />
        <p className="subtitle" key={"Contribution-4"} id="Contribution-4">
          4. Entrepreneurship (For transformation of scientific research
          achievements)
        </p>
        <ContentCard
          content={` 
            <p>
            Our journey in the iGEM 2023 competition extends beyond the realm of scientific exploration and delves deep into the entrepreneurial landscape. Building on our current computational results, we drew a detailed business plan for BioRocket - a therapeutic protein delivery service company, inside which we make detailed analysis of the opportunity, the entrepreneur and the winning team, commercialization, marketing strategy, risk and uncertainty, financial planning growth potential, etc.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/contribution-figure6.jpg'
            alt='Figure 6. Front cover of our business plan'
            class='content-figure'
            style='width:40%'
            />
            </div>
            <p class='content-legend'>
            Figure 6. Front cover of our business plan
            </p>
            <p>
            It's worth mentioning the experience that we reached out to Dr. Zongyang Yang, the founder of Emergence Synbio, a startup specializing in large fragment DNA synthesis. As an entrepreneur, Dr. Yang has provided valuable insights into the commercialization direction of our project. In addition, we have an agreement with Dr. Yang to maintain close communication and plan to initiate relatively high-throughput eCIS protein synthesis next year.
            </p>
            <br/>
            <p>
            We have not only pushed the boundaries of synthetic biology but also paved the way for iGEMers to embark on entrepreneurial journeys, armed with innovative research, market insights, risk management strategies, and a collaborative mindset. We have illuminated the path of "Creating a data-driven company and serving downstream users as upstream," empowering the next generation of entrepreneurs to make a meaningful impact in the biotechnology landscape.
            </p>
            <br/>
            <p>
            For details, see <a href="https://2023.igem.wiki/sysu-software/entrepreneurship">Entrepreneurship</a>.
            </p>
              `}
        />
      </div>
      <Footer />
    </div>
  );
}
